import React, { useState, useEffect } from "react";
import { Spin, message } from "antd";
import orderService from "../../services/OrderLists";

/**
 * ZipFilesDownload Component
 *
 * Downloads all order files as a ZIP archive when the component mounts.
 * Automatically triggers the download using the order's task key and
 * closes the modal once the download completes (or fails).
 *
 * @param {Object} orderData - The order object containing order details (expects orderData.data.key)
 * @param {Function} handleModalClose - Callback to close the parent modal after download
 */
function ZipFilesDownload({ orderData, handleModalClose }) {
  // Track loading state to show/hide spinner
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    /**
     * Initiates the ZIP file download via the order service.
     * On success, shows a success message and closes the modal.
     * On failure, silently closes the modal.
     * The finally block ensures the spinner stops and modal closes regardless of outcome.
     */
    const handleDownload = async () => {
      setLoading(true);
      try {
        // Call the API to download all order files as a ZIP using the task key
        const result = await orderService.downloadZipFile(orderData?.data?.key);
        if (result.success) {
          message.success("Files downloaded successfully!");
          handleModalClose();
        }
      } catch (error) {
        // Close modal on error — error toast is handled by the service layer (catchError)
        handleModalClose();
      } finally {
        setLoading(false);
        handleModalClose();
      }
    };

    // Only trigger download if the order key is available
    if (orderData?.data?.key) {
      handleDownload();
    }
  }, [orderData]);

  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      {/* Spinner shown while the ZIP download is in progress */}
      <Spin spinning={loading} tip="Downloading files..." />
    </div>
  );
}

export default ZipFilesDownload;
